import axios from "axios";

// const api_endpoint = "https://staging.enterprise.api.docmasweetspot.ca";
// const api_endpoint = "http://127.0.0.1:5001";
// const api_endpoint = 'https://fn6mi7qqjd.execute-api.us-east-2.amazonaws.com/dev'
const api_endpoint = 'https://d6itaje8h6.execute-api.us-east-2.amazonaws.com/prod'

function get_all_users(token) {
  let api_url = api_endpoint + "/user_management/get_all_users";
  let data = {};
  return axios_post_call(api_url, data, token);
}

function get_user_orgs(token, user_id) {
  let api_url = api_endpoint + "/user_management/get_user_orgs";
  let data = { user_id: user_id };
  return axios_post_call(api_url, data, token);
}

function create_new_user(token, user_payload) {
  let api_url = api_endpoint + "/user_management/create_new_user";
  return axios_post_call(api_url, user_payload, token);
}

function get_org_users(token, org_id) {
  let api_url = api_endpoint + "/org_management/get_org_members";
  let data = { org_id: org_id };
  return axios_post_call(api_url, data, token);
}
function add_org_members(token, org_id, user_ids) {
  let api_url = api_endpoint + "/org_management/add_org_members";
  let data = { org_id: org_id, user_ids: user_ids };
  return axios_post_call(api_url, data, token);
}

function invite_org_member(token, org_id, inviter, invitee_email) {
  let api_url = api_endpoint + "/org_management/invite_org_member";
  let data = { org_id: org_id, inviter: inviter, invitee_email: invitee_email };
  return axios_post_call(api_url, data, token);
}

function remove_org_member(token, org_id, user_ids) {
  let api_url = api_endpoint + "/org_management/remove_org_member";
  let data = { org_id: org_id, user_ids: user_ids };
  return axios_post_call(api_url, data, token);
}

function update_user_permission(token, payload) {
  let api_url = api_endpoint + "/access_management/update_user_permission";
  return axios_post_call(api_url, payload, token);
}

function get_available_access(token, payload) {
  let api_url = api_endpoint + "/access_management/get_available_access";
  return axios_post_call(api_url, payload, token);
}

function assign_user_access(token, payload) {
  let api_url = api_endpoint + "/access_management/assign_user_access";
  return axios_post_call(api_url, payload, token);
}

function get_project_tab_access(token, payload) {
  let api_url = api_endpoint + "/access_management/get_project_tab_access";
  return axios_post_call(api_url, payload, token);
}

function get_user_admin_access(token, payload) {
  let api_url = api_endpoint + "/access_management/u_a";
  return axios_post_call(api_url, payload, token);
}

function get_all_project_tab_access(token, payload) {
  let api_url = api_endpoint + "/access_management/get_all_project_tab_access";
  return axios_post_call(api_url, payload, token);
}

function update_project_tab_access(token, payload) {
  let api_url = api_endpoint + "/access_management/update_project_tab_access";
  return axios_post_call(api_url, payload, token);
}

/*
Base Caller functions
*/
function axios_post_call(api_url, data, token) {
  return new Promise(function (resolve, reject) {
    axios
      .post(api_url, data, { headers: { Authorization: `Bearer ${token}` } })
      .then((res) => {
        if (res.status == 200) {
          resolve(res.data);
        } else {
          reject();
        }
      })
      .catch((e) => {
        reject(api_url + e);
      });
  });
}

export default {
  get_all_users,
  get_user_orgs,
  get_org_users,
  create_new_user,
  add_org_members,
  remove_org_member,
  invite_org_member,
  get_available_access,
  assign_user_access,
  get_project_tab_access,
  update_user_permission,
  get_user_admin_access,
  get_all_project_tab_access,
  update_project_tab_access,
};
